export default __webpack_public_path__ + "static/media/logo.efa8b148.svg";